<template>

        <div class="container centerall">
					<br>
					<br><br>
					<br>
					<br>
                  <img src="/img/banner/404.png" class="notfound" height="560px">
          <br>
					<h3>Страница не найдена</h3>
                </div>

</template>

<script>
    export default {
        mounted() {
           
        }
    }
</script>

<style>
.notfound{
  height: 560px;
  width: 794px!important;
  max-width: fit-content!important;
}
</style>